const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSAxLjE0OTIyVjlIMjAuMDgwNkw5IDIyLjg1MDhWMTVIMy45MTkzN0wxNSAxLjE0OTIyWk0xMyA2Ljg1MDc4TDguMDgwNjIgMTNIMTFWMTcuMTQ5MkwxNS45MTk0IDExSDEzVjYuODUwNzhaIi8+Cjwvc3ZnPgo=";
export {
  I as default
};
//# sourceMappingURL=pover_on-b2e69363.mjs.map
